import React from 'react'
import { Link, useHistory } from 'react-router-dom'

const ClientFinish = () => {
  const history: any = useHistory()
  const success: boolean = history.location.state.success
  return (
    <React.Fragment>
      <div className='container grid justify-items-center mt-20 md:mx-auto'>
        {success ? (
          <>
            <h2 className='mt-14 mb-5 text-3xl text-center w-10/12 leading-6'>
              Cliente creado
            </h2>

            <img
              src='../check.png'
              alt='Success'
              className='w-2/4 mt-5 mb-10 md:w-1/5'
            />
          </>
        ) : (
          <>
            <h2 className='mt-14 mb-5 text-3xl text-center w-10/12 leading-6'>
              Ocurrió un error al procesar el cliente
            </h2>
            <img
              src='error.png'
              alt='Error'
              className='w-2/4 mt-5 mb-10 md:w-1/5'
            />
          </>
        )}
        <Link to='/tecnico/panel'>
          <button
            type='button'
            className='bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl'>
            Ir al inicio
          </button>
        </Link>
      </div>
    </React.Fragment>
  )
}

export default ClientFinish
